import find from 'lodash/fp/find';
import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import isEmpty from 'lodash/fp/isEmpty';
import filter from 'lodash/fp/filter';
import size from 'lodash/fp/size';
import sum from 'lodash/fp/sum';
import add from 'lodash/fp/add';

export const getProductsFromState = get('products.products.items');

const findById = id => find({ id });

export const byId = (state, id) => flow(
  getProductsFromState,
  findById(id),
)(state, id);

const getName = getOr('', 'name');
const getPercentage = getOr('', 'percentage');
const formatTax = (item) => {
  if (!item) return '-';
  return `${getName(item)} ${getPercentage(item)}%`;
};

const getProductCategoryId = get('productCategoryId');
const getCategoryName = (product, categories) => flow(
  getProductCategoryId,
  id => findById(id)(categories),
  getName
)(product);

const getProductBrandId = get('productBrandId');
const getBrandName = (product, brands) => flow(
  getProductBrandId,
  id => findById(id)(brands),
  getName,
)(product);

export const getFormattedTaxes = item => flow(
  getOr([null], 'taxes'),
  map(formatTax),
)(item);

const getAssignments = get('assignments');

export const getAssignmentsInventory = product => flow(
  getAssignments,
  map(getOr(0, 'inventory')),
  sum,
)(product);

export const getTotalInventory = product => flow(
  getAssignmentsInventory,
  add(product.inventory)
)(product);

const getProductVendorId = get('vendorId');
const getVendorName = (product, vendors) => flow(
  getProductVendorId,
  id => findById(id)(vendors),
  getName,
)(product);

const mapProduct = (categories, brands, vendors) => product => ({
  ...product,
  category: getCategoryName(product, categories),
  brand: getBrandName(product, brands),
  tax: getFormattedTaxes(product),
  totalInventory: getTotalInventory(product),
  vendorName: getVendorName(product, vendors),
});
const mapProducts = (categories, brands, vendors) => map(mapProduct(categories, brands, vendors));

export const getProducts = (state, categories, brands, vendors) => flow(
  getProductsFromState,
  mapProducts(categories, brands, vendors),
)(state);

export const lowInventoryProductsCount = flow(
  getProductsFromState,
  filter(product => product.inventory <= product.lowInventoryThreshold),
  size
);

export const getNoProducts = flow(
  getProductsFromState,
  isEmpty,
);

export const getProductsCategories = flow(
  getProductsFromState,
  map('productCategoryId')
);

export const getProductsBrands = flow(
  getProductsFromState,
  map('productBrandId')
);
